import {getCurrentLayout} from "../../appLayout";
import {getPartIdFromLixilCategoryName} from "../lookLixilCategories";

/**
 * @param shopCategoryId {string}
 * @returns {object} featureGroup
 */
export const getFeatureGroupFromUrl = (shopCategoryId) => {
  if (!shopCategoryId) {
    return null
  }
  const layout = getCurrentLayout();
  return layout.getFeatureGroupByPartId(shopCategoryId)
    || layout.getFeatureGroupByPartId(getPartIdFromLixilCategoryName(shopCategoryId));
}

/**
 * @param shopFeatureGroup {featureGroupInterface}
 * @param skuId {string}
 * @param withSharedFeatureName {boolean}
 * @returns {featureInterface} feature
 */
export const getFeatureFromUrl = (shopFeatureGroup, skuId, withSharedFeatureName = false) => {
  if (!shopFeatureGroup || !skuId) {
    return null
  }
  const layout = getCurrentLayout();
  return layout.getFeatureBySku(skuId, shopFeatureGroup ? shopFeatureGroup.partId : "", true, withSharedFeatureName)
}
